export default __webpack_public_path__ + "5654ae9.png";